export const ROUTES = {
  strategies: "strategies",
  users: "users",
  assets: "assets",
  sync: "sync",
  asset: ":assetId",
  root: "/",
  any: "*",
};
